<template>
  <div class="cover">
    <div class="header">
      <div class="title">全场景覆盖</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="left">
        <div class="item" v-for="item in coverList" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
      <div class="right">
        <img :src="coverImg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import coverImg from "../../../../assets/product/coverImg.png";

export default {
  setup() {
    return reactive({
      coverImg: coverImg,
      coverList: [
        {
          id: 1,
          title: "有偿维修",
          text: "划分有偿维修区域，价格透明。",
        },
        {
          id: 2,
          title: "免费维修",
          text: "划分免费维修区域，自主选择，一键报修。",
        },
        {
          id: 3,
          title: "公区维修",
          text: "划分公共区域，发现问题，随时报修。",
        },
        {
          id: 4,
          title: "室内维修",
          text: "室内居家设施，专栏设置，多项选择，报修方便。",
        },
        {
          id: 5,
          title: "卫生保洁",
          text: "划分环境卫生、绿化设施维修区域，自主选择，一键报修。",
        },
      ],
    });
  },
};
</script>

<style scoped>
.cover {
  width: 1180px;
  margin: 80px auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}
.body .left .item {
  margin-bottom: 40px;
}
.body .left .item .text {
  margin-top: 20px;
  font-size: 14px;
}

.body .right img {
  width: 609px;
}
</style>
